const React = require('react');
const isNode = (typeof process !== 'undefined');

class PropertyPrice extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const prices = Array.isArray(this.props.price) ? this.props.price : [this.props.price];

        const PRICE_LABEL = [
            { name: 'day', desc: 'pr. dag' },
            { name: 'week', desc: 'pr. uke' },
            { name: 'year', desc: 'pr. år' },
            { name: 'deposit', desc: 'Depositum' },
            { name: 'main', desc: 'pr. måned' }
        ];
        return (
            <div className="rental__fact-wrapper">
                {prices.map(price => {
                    const { value, name } = price._attributes;
                    const priceType = PRICE_LABEL.find(def => def.name === name);
                    const includes = price['finn:field'] ? price['finn:field']['_text'] : null;
                    return name === 'deposit' ? (
                        <div className="rental__fact rental__fact--full">
                            <span className="rental__fact-header">Depositum</span>
                            <div className="rental__fact-value">
                            {value} {includes && <span>(inkluderer {includes})</span>}
                            </div>

                            {name !== 'deposit' && <span className="rental__fact-header">Pris</span>}
                            {name !== 'deposit' && (
                                <div className="rental__fact-value">
                                    {value} {priceType.desc} {includes && <span>(inkluderer {includes})</span>}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="rental__fact rental__fact--full">
                            <span className="rental__fact-header">Pris</span>
                            <div className="rental__fact-value">
                                {value} {priceType.desc} {includes && <span>(inkluderer {includes})</span>}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}

module.exports = PropertyPrice;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/PropertyComponents/PropertyPrice/index.jsx